import React from 'react';
import { Box } from 'lmc-ui-library';
import SubPageTemplate from '../../partials/SubPageTemplate/SubPageTemplate';
import styles from './Tasklist.module.scss';
import { ToDoTask, CompletedTask } from './Task';
import { ITask } from 'modules/cm/Tasks/Task';

interface Props {
  completedTasks: ITask[];
  todoTasks: ITask[];
  caseId: string;
  completeTask: (caseId: string, task: ITask) => void;
  setTaskAsNotApplicable: (caseId: string, task: ITask) => void;
  undoTask: (caseId: string, task: ITask) => void;
}

const Tasklist = ({ completedTasks, todoTasks, caseId, completeTask, setTaskAsNotApplicable, undoTask }: Props) => {
  return (
    <div>
      <SubPageTemplate title="New tasks">
        <Box className={styles.tasklist}>
          {todoTasks.length > 0 ? (
            <ul>
              {todoTasks.map((task, i) => (
                <li key={`todo-${i}`}>
                  <ToDoTask
                    task={task}
                    onComplete={completeTask.bind(null, caseId, task)}
                    onNotApplicable={setTaskAsNotApplicable.bind(null, caseId, task)}
                  />
                </li>
              ))}
            </ul>
          ) : (
            <div className={styles.noItems}>No new tasks</div>
          )}
        </Box>
      </SubPageTemplate>

      <SubPageTemplate title="Completed" className={styles.taskgroup}>
        <Box className={styles.tasklist}>
          {completedTasks.length > 0 ? (
            <ul>
              {completedTasks.map((task, i) => (
                <li key={`completed-${i}`}>
                  <CompletedTask task={task} onUndo={undoTask.bind(null, caseId, task)} />
                </li>
              ))}
            </ul>
          ) : (
            <div className={styles.noItems}>No tasks completed yet</div>
          )}
        </Box>
      </SubPageTemplate>
    </div>
  );
};

export default Tasklist;
